function domainEnvCheck(env: string) {
  return window.location.hostname.indexOf(env) > -1;
}

export function domainsEnvCheck(envs: string[]) {
  return envs.some((env) => domainEnvCheck(env));
}
